import { GroupedReportLineItems } from '../ScopeReportTypes';

/**
 * Filters sowData to only include tenant responsibility items
 */
export const filterTenantRespGroups = (sowData: GroupedReportLineItems): GroupedReportLineItems => {
  const filtered: GroupedReportLineItems = {};
  Object.entries(sowData).forEach(([key, items]) => {
    const tenantRespItems = items.filter(item => item.isTenantRespLineItem === true);
    if (tenantRespItems.length > 0) {
      filtered[key] = tenantRespItems;
    }
  });
  return filtered;
};
